import formatTableJson from '@/config/tableComponentParams.js'
export default formatTableJson([
  {
    filed: 'img',
    label: '产品图片',
    type: 'image'
  },
  {
    filed: 'name',
    label: '型号名称'
  },
  {
    filed: 'identifier',
    label: '型号编码'
  },
  {
    filed: 'typeName',
    label: '产品种类'
  },
  {
    filed: 'seriesName',
    label: '产品系列'
  }
])
